import {
  CmsPageVersionClient,
  CmsPageVersionQuery,
} from 'services/api/api-client';
import { queryClient } from 'services/api/query-client-helper.ts';
import { LexicalEditor } from 'lexical';

type CachedData =
  | {
      content: string;
    }
  | undefined;

export const setVersionAsActive = async ({
  versionId,
  setEditorState,
  setIsVersionsModeActive,
  handleSubmitDefault,
  activeEditor,
}: {
  versionId: number | null;
  setEditorState: (value: string) => void;
  setIsVersionsModeActive: (value: boolean) => void;
  handleSubmitDefault: () => Promise<void>;
  activeEditor: LexicalEditor | null;
}) => {
  if (versionId) {
    try {
      const queryKey = CmsPageVersionQuery.getVersionDetailsQueryKey(versionId);
      const data = queryClient.getQueryData(queryKey) as CachedData;

      let fetchedContent = data?.content;

      if (!fetchedContent) {
        fetchedContent = (
          await CmsPageVersionClient.getVersionDetails(versionId)
        ).content;
      }

      const actualContent = JSON.stringify(
        activeEditor?.getEditorState().toJSON(),
      );

      setEditorState(actualContent ?? fetchedContent);

      await handleSubmitDefault();
      setIsVersionsModeActive(false);
    } catch (e) {
      console.error('Failed to set active version', e);
    }
  }
};
